import MaterialIcon from '@components/common/MaterialIcon';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  currentIndex: number;
  totalConversations: number;
  preApprovedCount: number;
};

export const ConversationReviewSubheader: React.FC<Props> = ({
  currentIndex,
  totalConversations,
  preApprovedCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className='conversation-review-modal__subheader'>
      <div className='conversation-review-modal__subheader-title'>
        <MaterialIcon
          icon='search'
          classes={['conversation-review-modal__subheader-title-icon']}
        />
        <span className='conversation-review-modal__subheader-title-text'>
          {t('train-ai.conversation-review.section-label')}
        </span>
      </div>
      <span className='conversation-review-modal__subheader-progress'>
        {t('train-ai.conversation-review.question-prefix')}{' '}
        <span className='conversation-review-modal__subheader-progress-current'>
          {currentIndex + 1}
        </span>{' '}
        {t('train-ai.conversation-review.of-total', {
          total: totalConversations,
        })}{' '}
        {'-'}{' '}
        <span className='conversation-review-modal__subheader-progress-pre-approved'>
          {preApprovedCount}
        </span>{' '}
        {t('train-ai.conversation-review.pre-approved-label')}
      </span>
    </div>
  );
};
